export const selectFiltersConfig = {
  entityType: {
    type: 'select',
    label: 'Entity Type',
    placeholder: (t) => `${t('Filter by')} ${t('Entity Type').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  entityCategory: {
    type: 'select',
    label: 'Entity Category',
    placeholder: (t) => `${t('Filter by')} ${t('Entity Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  entitySubCategory: {
    type: 'select',
    label: 'Entity Sub Category',
    placeholder: (t) => `${t('Filter by')} ${t('Entity Sub Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  source: {
    type: 'select',
    label: 'Source',
    placeholder: (t) => `${t('Filter by')} ${t('Source').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  origin: {
    type: 'select',
    label: 'Origin',
    placeholder: (t) => `${t('Filter by')} ${t('Origin').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

